import { Loader2 } from 'lucide-react';

interface Props {
  loading: boolean;
}

function DataTableLoader({ loading }: Props) {
  if (!loading) {
    return null;
  }

  return (
    <div className='flex justify-center items-center h-64'>
      <Loader2 className='h-8 w-8 animate-spin dark:text-white' />
    </div>
  );
}

export default DataTableLoader;
